export default __webpack_public_path__ + "static/media/_DSC0535.6c9709b0.JPG";